<template>
  <div class="choose-course-type">
    <Cascader
      v-model="courseTypes"
      clearable
      :render-format="format"
      :disabled="disabled"
      :placeholder="placeholder"
      :data="courseTypeListData"
      :load-data="loadData"
      change-on-select
      @on-change="handleCourseType"
    ></Cascader>
  </div>
</template>

<script>
import { courseTypeData } from './assets/data/index'
import resourcesManagementApi from '@/request/courseCenter/resources';
export default {
  name: 'choose-course-type',
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '请选择课程分类'
    },
    orgId: {
      type: [String, Number],
      default: '-1'
    },

  },
  data() {
    return {
      courseTypes: [],
      courseTypeListData: [...courseTypeData],
      classType: '0',
      courseTypeKind: null,
      courseTypeId: null,

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

    // 自定义级联显示内容
    format(labels, selectedData) {
      return labels.join('-');
    },
    // 课程分类级联，远程搜索
    async loadData(item, callback) {
      item.loading = true;
      const { message } = await resourcesManagementApi.getCourseTypeTapList({
        orgId: this.orgId,
        courseTypeKind: item.value
      });
      const data = message.map((course) => {
        return {
          label: course.courseTypeName,
          value: course.courseTypeId
        };
      });
      if (message.length) {
        item.children = data;
        item.loading = false;
      } else {
        item.children = [
          {
            label: '无',
            value: ''
          }
        ];
        item.loading = false;
      }
      callback();
    },
    //
    handleCourseType(value, select) {
      console.log(value);
      switch (value.length) {
        case 0:
          this.classType = null;
          this.courseTypeKind = null;
          this.courseTypeId = null;
          break;
        case 1:
          this.classType = value[0];
          this.courseTypeKind = null;
          this.courseTypeId = null;
          break;
        case 2:
          this.classType = value[0];
          this.courseTypeKind = value[1];
          this.courseTypeId = null;
          break;
        case 3:
          this.classType = value[0];
          this.courseTypeKind = value[1];
          this.courseTypeId = value[2];
          break;
        default:
          break;
      }
      this.$emit('on-change', {
        courseTypes: this.courseTypes,
        classType: this.classType,
        courseTypeKind: this.courseTypeKind,
        courseTypeId: this.courseTypeId
      });
    },
    getResult() {
      return {
        courseTypes: this.courseTypes,
        classType: this.classType,
        courseTypeKind: this.courseTypeKind,
        courseTypeId: this.courseTypeId
      }
    },
    handleClear() {
      this.courseTypeListData = [...courseTypeData];
      this.courseTypes = []
      this.classType = 0;
      this.courseTypeKind = null;
      this.courseTypeId = null;
    }
  }
}
</script>

<style lang="scss" scoped>
.choose-course-type {
}
</style>